import { render, staticRenderFns } from "./ModalSample.vue?vue&type=template&id=0ad95d54&lang=pug&"
import script from "./ModalSample.vue?vue&type=script&lang=js&"
export * from "./ModalSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports